import { cn } from '@/lib/cn';

interface IconProps {
  /** Material Symbols Outlined glyph name, e.g. "whatshot". */
  name: string;
  /** Override pixel size (default 22). */
  size?: number;
  /** Filled variant. */
  filled?: boolean;
  className?: string;
}

/**
 * Single icon source: Material Symbols Outlined.
 * Lucide / Heroicons / Feather are forbidden by canon.
 */
export const Icon = ({ name, size = 22, filled = false, className }: IconProps) => (
  <span
    aria-hidden
    className={cn('material-symbols-outlined', className)}
    style={{
      fontSize: size,
      fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' ${size}`,
    }}
  >
    {name}
  </span>
);
